import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import { Units, Colors } from 'Css';
import VideoChooser from '../VideoChooser';
import StoreVideoPlayer from '../../StoreVideoPlayer';

const css = oxygenCss({
  root: {},
  panel: {
    padding: Units.base
  },
  inputWrapper: {
    // width: 5 * (44 + Units.base),
    margin: `0 auto ${Units.base * 2}px`,
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    letterSpacing: '0.3px',
    backgroundColor: '#FBFBFB'
  },
  title: {
    padding: Units.base,
    color: Colors.text.Dark.secondary
  },
  input: {
    color: Colors.text.Dark.default,
    marginTop: Units.base,
    border: 0,
    padding: Units.base,
    outline: 'none',
    width: 358,
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
    '::placeholder': {
      color: Colors.text.Dark.disabled
    }
  }
});

class StoreVideoModuleEditor extends Component {
  static propTypes = {
    id: PropTypes.string,
    caption: PropTypes.string,
    src: PropTypes.string,
    embedUrl: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  changeCaption = event => {
    const { id } = this.props;
    const { value: caption } = event.target;
    StoreOverviewActions.updateModule(id, {
      caption
    });
  };

  changeVideo = src => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      src
    });
  };

  changeEmbedUrl = event => {
    const { id } = this.props;
    const { value: embedUrl } = event.target;
    StoreOverviewActions.updateModule(id, {
      embedUrl
    });
  };

  render() {
    const { src, embedUrl, caption } = this.props;
    const { getIntlMessage } = this.context;
    /*
          <VideoChooser
            onChange={this.changeVideo}
            title={getIntlMessage('video.upload')}
          />
    */
    return (
      <div>
        <div className={css.panel}>
          <div className={css.inputWrapper}>
            <div className={css.title}>{getIntlMessage('store.video')}</div>
            <input
              placeholder={getIntlMessage('store.chooseVideo')}
              onChange={this.changeEmbedUrl}
              value={embedUrl}
              className={css.input}
            />
          </div>
          <div className={css.inputWrapper}>
            <div className={css.title}>{getIntlMessage('Caption')}</div>
            <input
              placeholder={getIntlMessage('Caption')}
              onChange={this.changeCaption}
              value={caption}
              className={css.input}
            />
          </div>
          <StoreVideoPlayer src={embedUrl} />
        </div>
      </div>
    );
  }
}

export default StoreVideoModuleEditor;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/Modules/StoreVideoModuleEditor.js